import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import { importDecisionSheet, loadCreativeVersions } from "reducers/CreativeVersions";
import useFileSelector from "hooks/useFileSelector";
import { BasicAction, LinkAction } from "widgets/ActionMenu/";
import { loadCreative } from "reducers/CreativeDetails";
import { closeModal, openModal } from "reducers/Modal";
import { MODAL_TYPES, API_URL, DECISIONING_TYPES } from "utils/constants";
import { Icon } from "rhombus-react";

function buildContentFeedDecisioningAction(){
	const dispatch = useDispatch();
	const { libraryId, creativeId } = useParams();
	const contentFeedUrl = useSelector(state => state.creativeDetails?.contentFeedUrl);
	const creativeName = useSelector(state => state.creativeDetails?.name);

	return {
		name: "Assign Bulk Sheet Decisioning",
		renderChild() {
			if (!contentFeedUrl) {
				return null;
			}

			return (
				<BasicAction
					name="Assign Bulk Sheet Decisioning"
					iconName="fas fa-rss"
					handleClick={() => {
						return dispatch(openModal(MODAL_TYPES.CONTENT_FEED_DECISIONING_MODAL, {
							libraryId,
							creativeId,
							contentFeedUrl,
							onClose: () => dispatch(closeModal()),
							creativeName,
						}));
					}}
				/>
			);
		},
	};
}

function decisionTrees(){
	const dispatch = useDispatch()
		, { libraryId, creativeId } = useParams();

	return {
		name: "Decision Trees",
		renderChild(){
			return (
				<BasicAction
					name="Decision Trees"
					iconName="fas fa-sitemap"
					handleClick={() => dispatch(openModal(MODAL_TYPES.DECISION_TREE_MODAL, {
						libraryId,
						creativeId,
						onClose: () => dispatch(closeModal()),
					}))}
				 />
			);
		},
	};
}

function multiVariant(url){
	return {
		name: "Multi Variant Dynamic Creative",
		renderChild(){
			return (
				<LinkAction
					iconName = "fas fa-random"
					name = "Multi Variant Dynamic Creative"
					path = {`${url}modal/multi-variant/`}
				/>
			);
		},
	};
}

function importDecisionSheetAction() {
	const dispatch = useDispatch();
	const { libraryId, creativeId } = useParams();

	let selectFile = useFileSelector(
		(e) => {
			let file = e.currentTarget.files?.item(0);
			if (file) {
				let formData = new FormData();
				formData.append("filename", file);
				formData.append("creativeId", creativeId);
				dispatch(importDecisionSheet(creativeId, formData)).then((resp) => {
					if (resp.success) {
						dispatch(loadCreative(creativeId));
						dispatch(loadCreativeVersions(libraryId, creativeId));
					}
				});
			}
		},
		{
			accept: ".csv",
		}
	);

	return {
		name: "Import Decision Sheet",
		renderChild() {
			return (
				<BasicAction
					iconName = "upload"
					name = "Import Decision Sheet"
					handleClick = {selectFile}
				/>
			);
		},
	};
}

function downloadCurrentDecisionSheet() {
	const { libraryId, creativeId } = useParams()
		, hasDecisionSheet = useSelector(state => (state.creativeDetails?.decisioningType === DECISIONING_TYPES.DECISION_SHEET));

	function handleClick(e){
		e.stopPropagation();
	}

	return {
		name: "Download Current Decision Sheet",
		renderChild() {
			return hasDecisionSheet && (
				<div className="action-item">
					<a
						download
						target="_blank"
						href={`${API_URL}/crm/v1/ui/creative-libraries/${libraryId}/creatives/${creativeId}/hedges/export`}
						onClick={handleClick}
					>
						<span className="action-icon">
							<Icon name="download" />
						</span>
						<span className="action-name">
							Download Current Decision Sheet
						</span>
					</a>
				</div>
			);
		},
	};
}

export function decisioningActions({ url, dependentValues }){
	return [
		buildContentFeedDecisioningAction(),
		decisionTrees(),
		multiVariant(url),
		importDecisionSheetAction(),
		downloadCurrentDecisionSheet()
	];
}
